"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var page_break_html_1 = __importDefault(require("./page-break.html"));
require("./page-break.less");
(function (module) {
    PageBreakController.$inject = [];
    function PageBreakController() {
        var $ctrl = this;
        angular.extend($ctrl, {
            remove: function () {
                $ctrl.bdyCtrl.removePageBreak($ctrl.pageBreak._id);
                $ctrl.pageBreakDeleted = true;
            }
        });
    }
    module.component('prPageBreak', {
        controller: PageBreakController,
        templateUrl: page_break_html_1.default,
        bindings: {
            pageBreak: '<',
            pageBreakDeleted: '<'
        },
        require: {
            bdyCtrl: '^^prBody'
        }
    });
}(angular.module('qualtrics.pr')));
